import type { CurrencyISO } from '@/constants/currencies';
import { getTradingItemCurrencyISO } from '@/utilities/getTradingItemCurrencyISO';
import { useExistingNarrative } from '@/hooks/narrative/useExistingNarrative';
import {
  DeferRender,
  MiniPriceChartDefinitions,
  NarrativeMiniPriceChart,
} from '@components/MiniPriceChart';
import useUser from '@/hooks/useUser';

type Props = {
  companyId: string;
};

export const NarrativeKeyMetricChart = ({ companyId }: Props) => {
  const { data: user } = useUser();
  const { data: existingNarrative, status } = useExistingNarrative({
    companyId,
    loggedIn: user.loggedIn,
  });

  if (status === 'pending' || status === 'error') {
    return <div>{/* Placeholder div to prevent CLS */}</div>;
  }

  const currencyISO = getTradingItemCurrencyISO(
    existingNarrative.Company.data.currencyInfo
  );
  const { myValuation } = existingNarrative.Company ?? {};

  return (
    <div
      data-cy-id="key-metric-value-1Y-Price-Chart"
      className="col-span-1 lg:mr-x3"
    >
      <MiniPriceChartDefinitions />
      <DeferRender>
        <NarrativeMiniPriceChart
          companyId={companyId}
          period="1Y"
          align="left"
          currencyISO={currencyISO as CurrencyISO}
          fairValue={myValuation?.fairValue ?? null}
        />
      </DeferRender>
    </div>
  );
};
